import React, { Fragment, useEffect } from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next'
import { CMSPath } from "../../../config/constant";
import DynamicBookingForm from "./getDynamicFormComponent";
import { toBool } from "../../JS/utility";
import { setAbortCheckinProcess } from "../../action/autoCheckin";
import { scrollToTop } from "../../../JS/scrollToTop";


const BookingForm = (props) => {

    const { t } = props;

    useEffect(()=>{
        if(props.abortCheckinProcess){
            props.goBack()
        }
    },[props.abortCheckinProcess])

    useEffect(()=>{
        setTimeout(()=>{
            scrollToTop();
          },100)
    },[])

    return (
        <Fragment>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => props.goBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                    {/* <p className="bold" style={{ color: "inherit" }}>{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                </div>
                <div class="cancel-check-in" onClick={()=>{props.cancelCheckinProcess()}}>
                                <div>Cancel </div>
                                    <span style={{}}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                    </span>
                        </div>

            </header>
            <section className="widgets padding-0 margin-0 container-bg additional_details">

                <div class="widget-header widget-header-checkin-inner additional-details">
                    { props.currentWidgetObj.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }

                    {
                        process.env.REACT_APP_NEWER_DESIGN=="true"?
                            <>
                            <div class="widget-header-title">{t("check_in.additional_details_heading")}</div>
                            {<div class="widget-header-subtitle">{t("check_in.additional_details_subheading")}</div>}
                            </>                       
                        :
                        <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                    }

                </div>

                <div className="widgets">
                    <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                        <h2 className="all-caps">{t('check_in.booking_details')}</h2>
                    </div>
                    <div className="form-window">
                        <div className="form-window-heading">
                            {t('check_in.additional_details')}
                        </div>
                        <DynamicBookingForm 
                            checkinGuestLoading={props.checkinGuest_loading}
                            phone={props.phone}
                            email={props.email}
                            birthDate={props.birthDate}
                            eta={props.eta}
                            address={props.address}
                            extraData={props.extraData}
                            firstName={props.firstName}
                            lastName={props.lastName}
                            isPreCheckInDone={props.isPreCheckInDone}
                            arrivalDate={props.arrivalDate}
                            departureDate={props.departureDate}
                            DynamicBookingFormRequestData={props.DynamicBookingFormRequestData}
                            dynamicFormIndex={props.dynamicFormIndex}
                            goBack={props.goBack}
                            next={props.next}
                            primaryButtonText={props.primaryButtonText}
                        />
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        checkInAddress: state.store2.checkInAddress,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        countryOptions: state.store2.guestBooking.countryOptions,
        allergyOptions: state.store2.guestBooking.allergyOptions,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
        preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
        abortCheckinProcess: state.store2.abortCheckinProcess

    }
}

export default connect(mapStateToProps, {setAbortCheckinProcess})(withTranslation('translations')(BookingForm));